module.exports = __webpack_public_path__ + "img/3.67200910.jpeg";